// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "js/" + chunkId + "-" + {"27":"3792d36e","348":"a20e2ccb","571":"71225f0f","924":"0d654211"}[chunkId] + ".chunk.js";
};